import {
    Heart,
    MessageCircle,
    Bookmark,
    Share2,
    MoreHorizontal
} from "lucide-react";

import { motion } from "framer-motion";
import ImageCarousel from "./ImageCarousel";

export default function SocialPostCard({

    post,

    onLike,

    onComment,

    onShare,

    onBookmark,

    onOpen

}) {

    return (

        <motion.div

            layout

            whileHover={{
                y: -3
            }}

            className="
                rounded-[30px]
                bg-white/70
                backdrop-blur-xl
                border
                border-white/30
                shadow-xl
                overflow-hidden
            "

        >

            {/* HEADER */}

            <div className="p-6 flex justify-between">

                <div className="flex gap-4">

                    {/* <img

                        src={post.user.avatar}

                        className="
                            w-14
                            h-14
                            rounded-full
                            object-cover
                        "

                        alt=""

                    /> */}

                    <div>

                        {/* <div className="font-bold">

                            {post.user.name}

                        </div> */}

                        {/* <div className="text-gray-500 text-sm">

                            @{post.user.username}

                        </div> */}

                        <div className="text-xs text-gray-400 mt-1">

                            {post.createdAt}

                        </div>

                    </div>

                </div>

                <button>

                    <MoreHorizontal />

                </button>

            </div>

            {/* CONTENT */}

            <div className="px-6">

                {

                    post.title &&

                    <h2
                        className="
                            text-2xl
                            font-bold
                            mb-3
                        "
                    >

                        {post.title}

                    </h2>

                }

                <p
                    className="
                        leading-8
                        text-gray-700
                        whitespace-pre-wrap
                    "
                >

                    {post.content}

                </p>

            </div>

            {/* IMAGES */}

            {

                post.media?.length > 0 &&

                <div className="mt-6">

                    <ImageCarousel

                        media={post.media}

                    />

                </div>

            }

            {/* STATS */}

            <div
                className="
                    px-6
                    py-4
                    flex
                    justify-between
                    text-sm
                    text-gray-500
                "
            >

                <span>

                    ❤️ {post.likeCount}

                </span>

                <span>

                    💬 {post.commentCount}

                </span>

                <span>

                    👀 {post.views}

                </span>

            </div>

            {/* ACTIONS */}

            <div
                className="
                    border-t
                    border-gray-100
                    grid
                    grid-cols-4
                "
            >

                <ActionButton

                    icon={<Heart size={20} />}

                    label="Like"

                    onClick={() => onLike(post)}

                />

                <ActionButton

                    icon={<MessageCircle size={20} />}

                    label="Comment"

                    onClick={() => onComment(post)}

                />

                <ActionButton

                    icon={<Share2 size={20} />}

                    label="Share"

                    onClick={() => onShare(post)}

                />

                <ActionButton

                    icon={<Bookmark size={20} />}

                    label="Save"

                    onClick={() => onBookmark(post)}

                />

            </div>

        </motion.div>


    );
    <ThreadComments

        comments={post.comments}

        currentUser={currentUser}

        onAddComment={(text) => { }}

        onLikeComment={() => { }}

        onReply={() => { }}

    />

}

function ActionButton({

    icon,

    label,

    onClick

}) {

    return (

        <button

            onClick={onClick}

            className="
                py-4
                flex
                justify-center
                items-center
                gap-2
                hover:bg-gray-50
                transition
            "

        >

            {icon}

            <span className="hidden lg:block">

                {label}

            </span>

        </button>

    );

}